import {createMuiTheme} from '@material-ui/core/styles';

const palette = {
  primary: {main: '#2962FF'},
};

export default createMuiTheme({palette});
